module.exports = __webpack_public_path__ + "static/img/88.283b3dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/88.png
// module id = naxi
// module chunks = 1